import React from 'react';
import styles from './styles/sync-history.module.scss';

/**
 * A stored record as label / value rows. `fields` comes ready to render from
 * `buildRecordFields` (syncStoredData.utils.js): identifiers already dropped,
 * values already formatted and ordered, nested blocks already serialised.
 *
 * @param {Object} props
 * @param {Array<{ key: string, label: string, value: string, nested: boolean }>} props.fields
 * @param {string} [props.ariaLabel]
 */
function RecordFields({ fields, ariaLabel }) {
    if (!fields?.length) {
        return null;
    }
    return (
        <dl className={styles.fields} aria-label={ariaLabel}>
            {fields.map(({ key, label, value, nested }) => (
                <div key={key} className={nested ? styles.fieldNested : styles.field}>
                    <dt className={styles.fieldLabel}>{label}</dt>
                    <dd className={styles.fieldValue}>
                        {nested ? (
                            <pre className={styles.fieldJson}>{value}</pre>
                        ) : (
                            <span className={styles.fieldValueText}>{value}</span>
                        )}
                    </dd>
                </div>
            ))}
        </dl>
    );
}

export default RecordFields;
